import { gql } from '@apollo/client'
import { Separator } from '@farol-ds/react'
import { InfoSourceDisclaimer, RelatedDocuments } from '@jusbrasil-web/docview/core'
import { RefObject } from 'react'

import { DebugInfo } from '../debug-info'
import { LawsuitDecision } from '../lawsuit-decision'
import { MotionDetails } from '../motion-details'
import {
  MotionSidebar_DocumentFragment,
  MotionSidebar_ViewerFragment,
} from './__generated__/motion-sidebar.graphql'
import styles from './motion-sidebar.module.scss'

export interface MotionSidebarProps {
  document: MotionSidebar_DocumentFragment
  viewer: MotionSidebar_ViewerFragment | null
  contentRef: RefObject<HTMLDivElement>
}

export function MotionSidebar(props: MotionSidebarProps) {
  const { document, viewer, contentRef } = props

  return (
    <div className={styles.sidebar}>
      <MotionDetails document={document} />

      <LawsuitDecision document={document} />

      <RelatedDocuments document={document} viewer={viewer} enableOabValidation />

      <Separator className={styles.separator} />
      <InfoSourceDisclaimer title="De onde vêm as informações do Jusbrasil?">
        Todas as informações exibidas neste documento foram coletadas dos Sistemas dos Tribunais e
        dos Diários Oficiais. O Jusbrasil não produz, edita, modifica ou altera o conteúdo.
        Eventuais desidentificações e/ou exclusões de dados pessoais poderão ser realizadas como
        salvaguardas e em respeito aos direitos do titular dos dados.
      </InfoSourceDisclaimer>

      {viewer?.user?.isAdmin && <DebugInfo document={document} contentRef={contentRef} />}
    </div>
  )
}

MotionSidebar.fragments = {
  document: gql`
    fragment MotionSidebar_document on Document {
      ...MotionDetails_document
      ...LawsuitDecision_document
      ...RelatedDocuments_document
      ...DebugInfo_document
    }
    ${MotionDetails.fragments.document}
    ${LawsuitDecision.fragments.document}
    ${RelatedDocuments.fragments.document}
    ${DebugInfo.fragments.document}
  `,
  viewer: gql`
    fragment MotionSidebar_viewer on Profile {
      user {
        isAdmin
      }

      ...RelatedDocuments_viewer
    }
    ${RelatedDocuments.fragments.viewer}
  `,
}
